import { render, staticRenderFns } from "./PremiumBusinessPlanDescription.vue?vue&type=template&id=1f206728&scoped=true&"
import script from "./PremiumBusinessPlanDescription.vue?vue&type=script&lang=js&"
export * from "./PremiumBusinessPlanDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f206728",
  null
  
)

export default component.exports